export const environment = {
  production: false,
  api: {
    base: '/api'
  },
  apiHttpOptions: {
    withCredentials: true
  }
}
